module.exports = __webpack_public_path__ + "static/media/ad.2d928813.svg";